import axios from 'axios';
import { getVuexPeristence } from '../';

var testIsMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (testIsMobile.Android() || testIsMobile.BlackBerry() || testIsMobile.iOS() ||
            testIsMobile.Opera() || testIsMobile.Windows());
    }
};

axios.interceptors.response.use((response) => { // intercept the global error
    return response;
}, function (error) {
    if (error.response.status === 401) {
        window.location.href = '/login';
        return;
    }
    return Promise.reject(error);
});

export default {
    namespaced: true,
    state: {
        maxImages: undefined,
        currentImagesQuota: undefined,
        currentActiveImagesQuota: undefined,
        isPro: undefined,
        profil: {},
        transitionPage: 'fade-in-up',
        windowSize: 0,
        displayOverlay: false,
        isMobile: false,
        menuDrawable: getVuexPeristence('app.menuDrawable', true),
        toggleMenu: false
    },
    getters: {
        maxImages: (state) => state.maxImages,
        currentImagesQuota: (state) => state.currentImagesQuota,
        currentActiveImagesQuota: (state) => state.currentActiveImagesQuota,
        isPro: (state) => state.isPro,
        profil: (state) => state.profil,
        transitionPage: (state) => state.transitionPage,
        displayOverlay: (state) => state.displayOverlay,
        windowSize: (state) => state.windowSize,
        isMobile: (state) => state.isMobile,
        menuDrawable: (state) => state.menuDrawable,
        toggleMenu: (state) => state.toggleMenu
    },
    mutations: {
        SET_IMG_QUOTA: (state, { dict }) => {
            state.maxImages = dict.maxImages;
            state.currentImagesQuota = dict.currentImagesQuota;
            state.currentActiveImagesQuota = dict.currentActiveImagesQuota;
        },
        SET_IS_PRO: (state, value) => {
            state.isPro = value;
        },
        SET_PROFIL: (state, value) => {
            state.profil = value;
        },
        SET_TRANSITION_PAGE: (state, value) => {
            state.transitionPage = value;
        },
        SHOW_LOADING_OVERLAY: (state) => {
            state.displayOverlay = true;
        },
        HIDE_LOADING_OVERLAY: (state) => {
            state.displayOverlay = false;
        },
        REFRESH_WINDOW_SIZE: (state, value) => {
            switch (value) {
            case 'xs':
                state.windowSize = 220;
                break;
            case 'sm':
                state.windowSize = 400;
                break;
            case 'md':
                state.windowSize = 500;
                break;
            case 'lg':
                state.windowSize = 600;
                break;
            case 'xl':
                state.windowSize = 800;
                break;
            }
            state.isMobile = testIsMobile.any();
        },
        SET_MENU_DRAWABLE: (state, value) => {
            state.menuDrawable = value;
        },
        SET_TOGGLE_MENU: (state, value) => {
            state.toggleMenu = value.toggleMenu;
        }
    },
    actions: {
        refreshQuotas: (store) => {
            return new Promise((resolve, reject) => {
                axios.get('/quota').then((response) => {
                    store.commit('SET_IMG_QUOTA', { dict: response.data.msg.quotas });
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        postAugmentImage: (store, data) => {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('file', data.data);
                let url = '/augmentation/' + data.augmentationToken + '/image';
                axios.post(url, formData).then((response) => {
                    resolve(response.data);
                }, (err) => {
                    reject(err);
                });
            });
        },
        postImage: (store, data) => {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('file', data.data);
                let url = '/image';
                axios.post(url, formData).then((response) => {
                    resolve(response.data);
                }, (err) => {
                    reject(err);
                });
            });
        },
        deleteAugmentImage: (store, data) => {
            return new Promise((resolve, reject) => {
                axios.delete('/images/', { data: { '_ids': [data] } }).then(() => {
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        deleteCdn: (store, data) => {
            return new Promise((resolve, reject) => {
                axios.delete('/media/' + data).then(() => {
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        getProfil: (store) => {
            return new Promise(function (resolve, reject) {
                axios.get('/profil').then((response) => {
                    store.commit('SET_IS_PRO', response.data.isPro);
                    store.commit('SET_PROFIL', response.data.profil);
                    resolve();
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        updateProfil: function (store, value) {
            return new Promise(function (resolve, reject) {
                axios.put('/profil', value).then(() => {
                    store.commit('SET_PROFIL', value);
                    resolve();
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        showOverlay: (store) => {
            store.commit('SHOW_LOADING_OVERLAY');
        },
        hideOverlay: (store) => {
            store.commit('HIDE_LOADING_OVERLAY');
        },
        refreshWindowSize: (store, value) => {
            store.commit('REFRESH_WINDOW_SIZE', value);
        }
    }
};
